import { render, staticRenderFns } from "./ModalPopup.vue?vue&type=template&id=e21989b8&scoped=true"
import script from "./ModalPopup.vue?vue&type=script&lang=js"
export * from "./ModalPopup.vue?vue&type=script&lang=js"
import style0 from "./ModalPopup.vue?vue&type=style&index=0&id=e21989b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e21989b8",
  null
  
)

export default component.exports